import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logoImage from '../../assets/images/laconia-logo-white.png';

const FooterContainer = styled.footer`
  background-color: #000;
  color: #fff;
  padding: 4rem 0;
  border-top: 1px solid #222;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 5%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  margin-bottom: 2rem;
  
  h3 {
    color: #fff;
    font-weight: 600;
    margin-bottom: 1.5rem;
    font-size: 1.25rem;
    position: relative;
    display: inline-block;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #880000;
    }
  }
`;

const FooterLink = styled(Link)`
  color: #aaa;
  text-decoration: none;
  display: block;
  margin-bottom: 0.75rem;
  transition: color 0.2s ease;
  
  &:hover {
    color: #880000;
  }
`;

const FooterInfo = styled.p`
  color: #aaa;
  margin-bottom: 0.75rem;
  font-size: 0.95rem;
`;

/* Social links component removed */

const BottomBar = styled.div`
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #777;
  font-size: 0.9rem;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <img src={logoImage} alt="Laconia" style={{ height: '35px', marginBottom: '1.5rem', filter: 'brightness(0) invert(1)' }} />
          <FooterInfo>
            Providing expert fractional tech leadership, SRE, and security & compliance solutions for startups focused on sustainable growth.
          </FooterInfo>
          {/* Social links removed */}
        </FooterSection>
        
        <FooterSection>
          <h3>Services</h3>
          <FooterLink to="/services#tech-leadership">Fractional Tech Leadership</FooterLink>
          <FooterLink to="/services#sre">Site Reliability Engineering</FooterLink>
          <FooterLink to="/services#security">Security & Compliance</FooterLink>
          <FooterLink to="/services#advisory">Strategic Advisory</FooterLink>
        </FooterSection>
        
        <FooterSection>
          <h3>Company</h3>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/about">About</FooterLink>
          <FooterLink to="/services">Services</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </FooterSection>
        
        <FooterSection>
          <h3>Contact</h3>
          <FooterInfo>Email: info@laconia.ai</FooterInfo>
        </FooterSection>
      </FooterContent>
      
      <BottomBar>
        &copy; {currentYear} Laconia. All rights reserved.
      </BottomBar>
    </FooterContainer>
  );
};

export default Footer;
